const HEX6 = /^#([0-9a-fA-F]{6})$/
const HEX3 = /^#([0-9a-fA-F]{3})$/
const RGB_FN = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i

export function toRgbTriple(value: string): string | null {
  const v = value.trim()
  const hex6 = v.match(HEX6)
  if (hex6) {
    const h = hex6[1]
    return `${parseInt(h.slice(0, 2), 16)}, ${parseInt(h.slice(2, 4), 16)}, ${parseInt(h.slice(4, 6), 16)}`
  }
  const hex3 = v.match(HEX3)
  if (hex3) {
    const [r, g, b] = hex3[1].split('')
    return `${parseInt(r + r, 16)}, ${parseInt(g + g, 16)}, ${parseInt(b + b, 16)}`
  }
  const rgb = v.match(RGB_FN)
  if (rgb) return `${rgb[1]}, ${rgb[2]}, ${rgb[3]}`
  return null
}

export function isCssColorFunction(value: string): boolean {
  return /^(rgba?|hsla?)\(/i.test(value.trim())
}
